// extracted by mini-css-extract-plugin
export default {"menuContainer":"MultiSelect_menuContainer__7BIvg","openButton":"MultiSelect_openButton__U0UoQ","menu":"MultiSelect_menu__xyzR9","item":"MultiSelect_item__6MpoC"};